// Mock data for SUPERA Leadership PWA clone
// NOTE: Presentation data. Auth/CRUD use the real backend API.

export const brand = {
  name: "SUPERA",
  full: "Supera Leadership",
  heroImage:
    "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1600&q=85",
};

// Stat values are the same across languages; labels come from translations.
export const statValues = ["+23", "5", "20,000"];

// icon = lucide-react component name. img = program cover photo.
export const programs = [
  { id: "mini", name: "Supera Mini", age: "8 – 9 años", meta: "Explora", icon: "PartyPopper", color: "#F0546A", bg: "#FDE7EB",
    img: "https://images.unsplash.com/photo-1519340241574-2cec6aef0c01?crop=entropy&cs=srgb&fm=jpg&w=800&q=80" },
  { id: "kids", name: "Supera Kids", age: "10 – 11 años", meta: "Descubre", icon: "Target", color: "#E23B3B", bg: "#FCE4E4",
    img: "https://images.unsplash.com/photo-1517164850305-99a3e65bb47e?crop=entropy&cs=srgb&fm=jpg&w=800&q=80" },
  { id: "plus", name: "Supera Plus", age: "12 – 15 años", meta: "Crece", icon: "Rocket", color: "#3B7DF6", bg: "#E5EFFF",
    img: "https://images.unsplash.com/photo-1637073849563-5b0ac780ec34?crop=entropy&cs=srgb&fm=jpg&w=800&q=80" },
  { id: "high", name: "Supera High", age: "16 – 17 años", meta: "Lidera", icon: "Star", color: "#E9A400", bg: "#FBF0CE",
    img: "https://images.unsplash.com/photo-1531545514256-b1400bc00f31?crop=entropy&cs=srgb&fm=jpg&w=800&q=80" },
  { id: "pro", name: "Supera Pro", age: "18 – 22 años", meta: "Impacta", icon: "GraduationCap", color: "#1F2937", bg: "#ECEEF1",
    img: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?crop=entropy&cs=srgb&fm=jpg&w=800&q=80" },
  { id: "padres", name: "Padres y Madres", age: "Familia", meta: "Acompaña", icon: "Users", color: "#7C4DDB", bg: "#EEE6FB",
    img: "https://images.unsplash.com/photo-1542037104857-ffbb0b9155fb?w=800&q=80&auto=format&fit=crop" },
  { id: "docentes", name: "Docentes · Colegios", age: "Educación", meta: "Enseña", icon: "School", color: "#0EA5C4", bg: "#DEF4FA",
    img: "https://images.unsplash.com/photo-1577896851231-70ef18881754?w=800&q=80&auto=format&fit=crop" },
  { id: "admin", name: "Admin. Centros", age: "Gestión", meta: "Administra", icon: "Building2", color: "#54617A", bg: "#EDF0F4",
    img: "https://images.unsplash.com/photo-1517048676732-d65bc937f952?crop=entropy&cs=srgb&fm=jpg&w=800&q=80" },
  { id: "invitados", name: "Invitados", age: "Especiales", meta: "Participa", icon: "Ticket", color: "#DE4AA0", bg: "#FBE3F1",
    img: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?w=800&q=80&auto=format&fit=crop" },
  { id: "reclutamiento", name: "Reclutamiento", age: "Talento", meta: "Únete", icon: "Sprout", color: "#22A860", bg: "#E2F6EB",
    img: "https://images.unsplash.com/photo-1521791136064-7986c2920216?w=800&q=80&auto=format&fit=crop" },
  { id: "market", name: "Supera Market Program", age: "Negocios", meta: "Emprende", icon: "Store", color: "#EA7A17", bg: "#FCEBDA",
    img: "https://images.pexels.com/photos/7693692/pexels-photo-7693692.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { id: "coachjr", name: "Coach Junior Supera", age: "Formación", meta: "Guía", icon: "Dumbbell", color: "#0891B2", bg: "#DCF5FB",
    img: "https://images.unsplash.com/photo-1660463529814-a9f9050f3ebf?w=800&q=80&auto=format&fit=crop" },
  { id: "headcoach", name: "Head Coach Junior Supera", age: "Liderazgo", meta: "Dirige", icon: "Briefcase", color: "#4F46E5", bg: "#E7E9FD",
    img: "https://images.unsplash.com/photo-1524758870432-af57e54afa26?crop=entropy&cs=srgb&fm=jpg&w=800&q=80" },
];

export const valueIcons = ["Compass", "HeartHandshake", "Sparkles", "Globe2"];
export const testimonialAvatars = [
  "https://i.pravatar.cc/120?img=47",
  "https://i.pravatar.cc/120?img=12",
  "https://i.pravatar.cc/120?img=32",
];

export const countries = [
  "México", "Colombia", "España", "Argentina", "Chile", "Perú", "Ecuador",
  "Estados Unidos", "Guatemala", "Costa Rica", "Panamá", "República Dominicana",
  "Uruguay", "Paraguay", "Bolivia", "Venezuela", "Honduras", "El Salvador",
];

export const consents = [
  { id: "parental", label: "Consentimiento parental (menor de edad)" },
  { id: "general", label: "Acepto políticas generales del programa" },
  { id: "admin", label: "Acepto políticas administrativas y de pagos" },
  { id: "cancel", label: "Acepto política de cancelaciones" },
];
